




































































































import Vue from 'vue'
import { PropType } from '@vue/composition-api'
import SocialStreamConfigStore from '@/store/socialStream/socialStreamConfig'
import ProductsFromCatalogStore from '@/store/productsList/productsFromCatalog'
import PostStore from '@/store/socialStream/socialStreamPost'
import CatalogItemsLinkerStore from '@/store/catalogItemsLinker/catalogItemsLinker'
import { CatalogItem } from '@/store/socialStream/postApiRequestHelper'
import PostDetails from '@/views/components/socialStream/PostDetails.vue' 
import ProductsByRowList from '@/views/components/socialStream/ProductsByRowList.vue'
import PostListManage from '@/views/components/socialStream/PostListManage.vue'
import AssignedProductsList from '@/views/components/socialStream/AssignedProductsList.vue'
import { LinkIcon } from 'vue-feather-icons'

export default Vue.extend({
  components: {
    PostDetails, PostListManage, ProductsByRowList, AssignedProductsList, LinkIcon
  },
  data() {
    return {
      catalogId: 'not-set',
      sort: {
        field: 'id',
        order: 'asc',
      },
      query: '',
      productsListOpen: false,
    }
  },
  computed: {
    config() {
      return SocialStreamConfigStore.state.data.socialStreamConfig
    },
    catalogs() {
      return SocialStreamConfigStore.state.data.socialStreamCatalogs
    },
    dataLoading() {
      return SocialStreamConfigStore.state.dataLoading
    },
    postDataLoading() {
        return PostStore.state.dataLoading
    },
    likedItemsLoading() {
      return CatalogItemsLinkerStore.state.dataLoading
    },  
    assignedProductsCnt() {
      return CatalogItemsLinkerStore.state.linkedIds.length
    },
    productsListTitle() {
      return this.$t('socialStream.productList.title')
    }
  },
  watch: {
    dataLoading() {        
        this.getPostData()
        this.setProductsFromCatalogStore()
        this.setCatalogItemsLinker()
    },
  },
  mounted() {
    this.getData()
    if(!SocialStreamConfigStore.state.dataLoading){
        this.getPostData()
        this.setProductsFromCatalogStore()
        this.setCatalogItemsLinker()
    }
  },
  methods: {
    setProductsFromCatalogStore() {
      ProductsFromCatalogStore.commit('setSortByDirection', 'desc')
      ProductsFromCatalogStore.commit('setCatalogId', SocialStreamConfigStore.state.data.socialStreamCatalogs.productsCatalogId)
    },
    getData() {
      SocialStreamConfigStore.dispatch('getSocialStreamConfig', this.$route.params.configId)      
    },
    getPostData() {
      PostStore.commit('setPostId', this.$route.params.postId)
      PostStore.commit('setCatalogId', SocialStreamConfigStore.state.data.socialStreamCatalogs.instagramPostsCatalogId)      
      PostStore.dispatch('getPostData')
    },
    setCatalogItemsLinker() {
      CatalogItemsLinkerStore.commit('setContext', 'socialStream')
      CatalogItemsLinkerStore.commit('setInstanceId', this.$route.params.configId)
      CatalogItemsLinkerStore.commit('setMainCatalogId', SocialStreamConfigStore.state.data.socialStreamCatalogs.instagramPostsCatalogId)
      CatalogItemsLinkerStore.commit('setMainCatalogItemId', this.$route.params.postId)
      CatalogItemsLinkerStore.commit('setSubCatalogId', SocialStreamConfigStore.state.data.socialStreamCatalogs.productsCatalogId)
      CatalogItemsLinkerStore.dispatch('getLinkedItems')
    },
    hasProductsToDisplay() {
      return ProductsFromCatalogStore.state.productsList !== null
    },
    hasLinkedItems() {
      return CatalogItemsLinkerStore.state.linkedIds.length > 0
    },
    productsToDisplay() {
      return ProductsFromCatalogStore.state.productsList as Array<CatalogItem>
    },
    goToSocialStreamPostsList() {
      this.$router.push({ name: 'socialStreamPosts', params: { configId: this.$route.params.configId } })
    },
    assignedProducts() {
      return Object.values(CatalogItemsLinkerStore.state.linkedProducts)
    },
    linkItem(product: CatalogItem) {
      CatalogItemsLinkerStore.dispatch('linkItems', product)
    },
    detachItem(itemId: string) {
      CatalogItemsLinkerStore.dispatch('detachItems', itemId)
    },
    linkedProductsIds() {
      return Array.isArray(CatalogItemsLinkerStore.state.linkedIds) ? CatalogItemsLinkerStore.state.linkedIds : []
    },
  },
})
